const createOrderSlice = (set) => ({
   //Network
   selectedNetwork: { title: "Jag är osäker", id: 1111111, type: "natverk" },
   setSelectedNetwork: (newSelection) => {
      set({ selectedNetwork: newSelection })
   },
   resetSelectedNetwork: () => {
      set({ selectedNetwork: { title: "Jag är osäker", id: 1111111, type: "natverk" } });
   },

   //Broadband
   selectedBroadband: { title: "Nej tack!", id: 2222222, type: "bredband" },
   setSelectedBroadband: (newSelection) => {
      set({ selectedBroadband: newSelection })
   },
   resetSelectedBroadband: () => {
      set({ selectedBroadband: { title: "Nej tack!", id: 2222222, type: "bredband" } });
   },



   //Broadband equipment
   selectedBroadbandEquipment: [{ title: "Nej tack!", id: 4444444, type: "bredband-tillbehor" }],
   toggleSelectedBroadbandEquipment: (newSelection) => set((state) => {
      // Check if newSelection is equal to the default object or if the default object is already in the array
      if (newSelection.id === 4444444 || state.selectedBroadbandEquipment.some(element => element.id === 4444444)) {
         // If newSelection is equal to the default object or if the default object is already in the array, remove all other elements
         return { selectedBroadbandEquipment: [newSelection] };
      } else {
         // If newSelection is not equal to the default object, update the array
         const updatedPackages = state.selectedBroadbandEquipment.some((e) => e.id === newSelection.id)
            ? state.selectedBroadbandEquipment.filter((e) => e.id !== newSelection.id)
            : [...state.selectedBroadbandEquipment, newSelection];

         // Ensure there is at least one element in the array, and add the default object if it's empty
         const finalPackages = updatedPackages.length > 0 ? updatedPackages : [{ title: "Nej tack!", id: 4444444, type: "bredband-tillbehor" }];

         return { selectedBroadbandEquipment: finalPackages };
      }
   }),
   resetSelectedBroadbandEquipment: () => {
      set({ selectedBroadbandEquipment: [{ title: "Nej tack!", id: 4444444, type: "bredband-tillbehor" }] });
   },

   //Tv equipment
   selectedTvEquipment: [{ title: "Nej tack!", id: 5555555, type: "tv-tillbehor" }],
   toggleSelectedTvEquipment: (newSelection) => set((state) => {
      // Check if newSelection is equal to the default object or if the default object is already in the array
      if (newSelection.id === 5555555 || state.selectedTvEquipment.some(element => element.id === 5555555)) {
         // If newSelection is equal to the default object or if the default object is already in the array, remove all other elements
         return { selectedTvEquipment: [newSelection] };
      } else {
         // If newSelection is not equal to the default object, update the array
         const updatedPackages = state.selectedTvEquipment.some((e) => e.id === newSelection.id)
            ? state.selectedTvEquipment.filter((e) => e.id !== newSelection.id)
            : [...state.selectedTvEquipment, newSelection];

         // Ensure there is at least one element in the array, and add the default object if it's empty
         const finalPackages = updatedPackages.length > 0 ? updatedPackages : [{ title: "Nej tack!", id: 5555555, type: "tv-tillbehor" }];

         return { selectedTvEquipment: finalPackages };
      }
   }),
   resetSelectedTvEquipment: () => {
      set({ selectedTvEquipment: [{ title: "Nej tack!", id: 5555555, type: "tv-tillbehor" }] });
   },

   //Security
   selectedSecurity: { title: "Nej tack!", id: 6666666, type: "sakerhet" },
   setSelectedSecurity: (newSelection) => {
      set({ selectedSecurity: newSelection })
   },
   resetSelectedSecurity: () => {
      set({ selectedSecurity: { title: "Nej tack!", id: 6666666, type: "security" } });
   },


   //Tv Base Package

   selectedTvBasePackage: { title: "Nej tack!", id: 1231231, type: "tv_kanal_bas_paket" },
   setSelectedTvBasePackage: (newSelection) => {
      set({ selectedTvBasePackage: newSelection })
   },
   resetSelectedTvBasePackage: () => {
      set({ selectedTvBasePackage: { title: "Nej tack!", id: 1231231, type: "tv_kanal_bas_paket" } });
   },


   //Tv Packages
   selectedTvPackages: [{ title: "Nej tack!", id: 3333333, type: "tv_kanal_paket" }],
   toggleSelectedTvPackage: (newSelection) => set((state) => {
      // Check if newSelection is equal to the default object or if the default object is already in the array
      if (newSelection.id === 3333333 || state.selectedTvPackages.some(element => element.id === 3333333)) {
         // If newSelection is equal to the default object or if the default object is already in the array, remove all other elements
         return { selectedTvPackages: [newSelection] };
      } else {
         // If newSelection is not equal to the default object, update the array
         const updatedPackages = state.selectedTvPackages.some((e) => e.id === newSelection.id)
            ? state.selectedTvPackages.filter((e) => e.id !== newSelection.id)
            : [...state.selectedTvPackages, newSelection];

         // Ensure there is at least one element in the array, and add the default object if it's empty
         const finalPackages = updatedPackages.length > 0 ? updatedPackages : [{ title: "Nej tack!", id: 3333333, type: "tv_kanal_paket" }];

         return { selectedTvPackages: finalPackages };
      }
   }),
   resetSelectedTvPackage: () => {
      set({ selectedTvPackages: [{ title: "Nej tack!", id: 3333333, type: "tv_kanal_paket" }] });
   },



   //Tv Flex Channels
   selectedFlexChannels: [],
   toggleSelectedFlexChannels: (newSelection) => {
      set((state) => {
         const isSelected = state.selectedFlexChannels.some((e) => e.id === newSelection.id);

         if (isSelected) {
            // If already selected, remove it
            return {
               selectedFlexChannels: state.selectedFlexChannels.filter((e) => e.id !== newSelection.id),
            };
         } else {
            // If not selected, add it
            return {
               selectedFlexChannels: [...state.selectedFlexChannels, newSelection],
            };
         }
      });
   },
   resetSelectedFlexChannels: () => {
      set({ selectedFlexChannels: [] });
   },

   //Tv Cards
   digiCardAmount: 0,
   setDigiCardAmount: (newAmount) => {
      set({ digiCardAmount: newAmount })
   },
   unsetDigiCardAmount: () => {
      set({ digiCardAmount: 0 })
   },

   //Shipping option
   selectedShipping: null,
   setSelectedShipping: (newShipping) => {
      set({ selectedShipping: newShipping })
   },
   unsetSelectedShipping: () => {
      set({ selectedShipping: null })
   },

   //Shipping option
   shippingOptions: null,
   setShippingOptions: (newShipping) => {
      set({ shippingOptions: newShipping })
   },
   unsetShippingOptions: () => {
      set({ shippingOptions: null })
   },
});

export default createOrderSlice;
